






























import Vue from 'vue'
import ITranslation from '../../global/localisation/translation'
export default Vue.extend({
    data() {
        return {
            dialog: false
        }
    },
    props: {
        fab: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        changeEvent(language: ITranslation) {
            this.dialog = false
            this.$vuetify.lang.current = this.$translator.language.infos.code
            this.$translator.setLanguage(language.infos.code)
            this.$database.settings.languageCode = language.infos.code
            this.$database.save()
        }
    }
})
